/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const validationInformationsPacs = (
    data: any,
    irrecevable: boolean,
    isProjet: boolean = false,
) => {
    const errors = {
        dateEnregistrement: '',
        dateIrrecevabilite: '',
        motifIrrecevabilite: '',
        registre: '',
        numero: '',
        libelleCommuneDelegue: '',
    };

    // Uniquement en cas de statut "irrecevable"
    if (irrecevable) {
        if (_.isNil(data?.conventionDeclaration?.dateIrrecevabilite) || _.isEmpty(data?.conventionDeclaration?.dateIrrecevabilite)) {
            errors.dateIrrecevabilite = 'La date d\'irrecevabilité est obligatoire';
        }  else if (dayjs(data?.conventionDeclaration?.dateIrrecevabilite).isAfter(dayjs())) {
            errors.dateIrrecevabilite = 'La date d\'irrecevabilité ne peut pas être dans le futur';
        }
        if (_.isNil(data?.conventionDeclaration?.motifIrrecevabilite) || _.isEmpty(data?.conventionDeclaration?.motifIrrecevabilite)) {
            errors.motifIrrecevabilite = 'Le motif d\'irrecevabilité est obligatoire';
        }
    }
    
    // Date d'enregistrement : facultative pour un projet, mais jamais dans le
    // futur quand elle est saisie
    if (_.isNil(data?.conventionDeclaration?.dateEnregistrement) || _.isEmpty(data?.conventionDeclaration?.dateEnregistrement)) {
        if (!isProjet) {
            errors.dateEnregistrement = 'La date d\'enregistrement est obligatoire';
        }
    } else if (dayjs(data?.conventionDeclaration?.dateEnregistrement).isAfter(dayjs())) {
        errors.dateEnregistrement = 'La date d\'enregistrement ne peut pas être dans le futur';
    }

    // Registre
    if (_.isNil(data?.registre?.identifiant) || !_.isFinite(data?.registre?.identifiant)) {
        errors.registre = 'L\'identifiant du registre est obligatoire';
    }
    
    // Numérotation PACS
    if (_.isEmpty(data?.numero)) {
        errors.numero = 'La numérotation du PACS est obligatoire';
    }

    // Commune déléguée du lieu de saisie : le libellé est obligatoire dès que la case est cochée
    const adressePacs = data?.conventionDeclaration?.adressePacs;
    if (adressePacs?.communeDelegue && _.isEmpty(_.trim(adressePacs?.libelleCommuneDelegue))) {
        errors.libelleCommuneDelegue = 'Le libellé de la commune déléguée est obligatoire';
    }

    return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsPacs;
